import React from "react";
import Wall from "./Wall";
import Settings from "./Settings";

function normalizedPath() {
  const p = window.location.pathname.replace(/\/+$/, "") || "/";
  return p.toLowerCase();
}

export default function App() {
  if (normalizedPath() === "/settings") return <Settings />;
  return <Wall />;
}
